import * as React from 'react';
import Save from '../Save/Save';
import Plus from '../Plus/Plus';
import CompoundIconBase from '../CompoundIconBase/CompoundIconBase';
export default function SavePlus(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 16 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 16 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(CompoundIconBase, {
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement(Save, {
    width: width * 0.75,
    height: height * 0.75,
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    }
  }), /*#__PURE__*/React.createElement(Plus, {
    width: width / 2,
    height: height / 2,
    style: {
      position: 'absolute',
      top: '53.75%',
      left: '68.75%'
    }
  }));
}